import { CSSecondaryBtn } from "@/components/design-system/creatorshield/CSButton";
import Button from "@/components/ui/button";
import { Link, useLocation } from "react-router-dom";

export default function FinalCTA() {
  const location = useLocation();
  const isFAQPage = location.pathname.includes("/faq");
  const isSuccessStoriesPage = location.pathname.includes("/success-stories");
  const isLivePage = location.pathname.includes("/live");

  if (isFAQPage) {
    return (
      <div className="bg-[#FF6B35] relative h-[700px] flex items-center justify-center px-6 md:px-16">
        <div className="4xl:max-w-[100rem] 4xl:mx-auto text-center space-y-10">
          <h2 className="text-6xl md:text-7xl lg:text-8xl font-semibold text-white leading-normal max-w-4xl">
            Still Have Questions?
          </h2>
          <p className="text-lg text-white mx-auto leading-[30px] font-normal">
            Can't find the answer you're looking for? Our support team is here
            to help.
          </p>
          <Link to="/contact-us" className="inline-block">
            <CSSecondaryBtn name="Send us a message" className="py-5" />
          </Link>
        </div>
      </div>
    );
  }

  if (isSuccessStoriesPage) {
    return (
      <div className="bg-[#34c759] relative h-[700px] flex items-center justify-center px-6 md:px-16">
        <div className="4xl:max-w-[100rem] 4xl:mx-auto text-center space-y-10">
          <h2 className="text-6xl md:text-7xl lg:text-8xl font-semibold text-white leading-normal max-w-4xl">
            Ready to Join Them?
          </h2>
          <p className="text-lg text-white max-w-xl mx-auto leading-[30px] font-normal">
            Start protecting your content today and earn what's rightfully
            yours. The best 1-minute you'll ever spend.
          </p>
          <Link to="/esign" className="inline-block">
            <Button className="bg-white text-[#2e7d32] hover:bg-gray-100 rounded-[5px] font-semibold transition-colors">
              Start earning today
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  if (isLivePage) {
    return (
      <div className="bg-[#9146FF] relative h-[700px] flex items-center justify-center px-6 md:px-16">
        <div className="4xl:max-w-[100rem] 4xl:mx-auto text-center space-y-10">
          <h2 className="text-6xl md:text-7xl lg:text-8xl font-semibold text-white leading-normal max-w-4xl">
            <p className="mb-0">The Best 1-Minute</p>
            <p>You'll Ever Spend</p>
          </h2>
          <p className="text-lg md:text-xl text-white max-w-3xl mx-auto leading-[30px] font-normal">
            Join thousands of streamers protecting their content and earning
            what's rightfully theirs. Whatever you do, don't do nothing.
          </p>
          <Link to="/esign" className="inline-block">
            <CSSecondaryBtn 
              name="Start earning today" 
              className="!text-[#9146FF] hover:!bg-gray-100 rounded-[5px] font-semibold" 
            />
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#FF6B35] relative h-[700px] flex items-center justify-center px-6 md:px-16">
      <div className="4xl:max-w-[100rem] 4xl:mx-auto text-center space-y-10">
        <h2 className="text-6xl md:text-7xl lg:text-8xl font-semibold text-white leading-normal max-w-4xl">
          Ready to Claim What's Yours?
        </h2>
        <p className="text-lg text-white max-w-xl mx-auto leading-[30px] font-normal">
          Join 3,500+ creators who've recouped over $50 million in stolen
          revenue. Whatever you do, don't do nothing.
        </p>
        <Link to="/esign" className="inline-block">
          <CSSecondaryBtn name="Start earning today" className="py-5" />
        </Link>
      </div>
    </div>
  );
}
